export default "__VITE_ASSET__WtXzv65S__"